document.addEventListener('DOMContentLoaded', () => {
    $('.categories_slider-wrapper .slick').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        mobileFirst: true,
        variableWidth: true,
        prevArrow: $('.categories_slider-wrapper .arrow-left'),
        nextArrow: $('.categories_slider-wrapper .arrow-right'),
        responsive: [
            {
              breakpoint: 550,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: false
              }
            }
        ]
    });
})